export default __webpack_public_path__ + "70182bbae1898a591cc83b6792bb64e5.svg";